(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/assisted-focus-scroll/assets/javascripts/use-assisted-focus-scroll.js') >= 0) return;  svs.modules.push('/components/lb-utils/assisted-focus-scroll/assets/javascripts/use-assisted-focus-scroll.js');
"use strict";


const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef;
const INTERACTIVE_ELEMENT_TAGS = ['input', 'button', 'select', 'textarea', 'a'];
function scrollIntoViewWithOffset(element, _ref) {
  let _ref$offsetTop = _ref.offsetTop,
    offsetTop = _ref$offsetTop === void 0 ? 95 : _ref$offsetTop,
    _ref$offsetBottom = _ref.offsetBottom,
    offsetBottom = _ref$offsetBottom === void 0 ? 95 : _ref$offsetBottom;

  const rect = element.getBoundingClientRect();
  const absoluteTop = rect.top + window.pageYOffset;
  const absoluteBottom = rect.bottom + window.pageYOffset;
  const viewTop = window.pageYOffset + offsetTop;
  const viewBottom = window.pageYOffset + window.innerHeight - offsetBottom;
  if (absoluteTop < viewTop) {
    window.scrollTo({
      top: absoluteTop - offsetTop,
      behavior: 'smooth'
    });
  } else if (absoluteBottom > viewBottom) {
    window.scrollTo({
      top: absoluteBottom - window.innerHeight + offsetBottom,
      behavior: 'smooth'
    });
  }
}
const useAssistedFocusScroll = _ref2 => {
  let _ref2$offsetTop = _ref2.offsetTop,
    offsetTop = _ref2$offsetTop === void 0 ? 95 : _ref2$offsetTop,
    _ref2$offsetBottom = _ref2.offsetBottom,
    offsetBottom = _ref2$offsetBottom === void 0 ? 95 : _ref2$offsetBottom;
  const wrapperRef = useRef(null);
  useEffect(() => {
    const wrapper = wrapperRef.current;
    if (!wrapper) {
      return;
    }
    function handleFocus(e) {
      var _target$classList;
      const target = e.target;
      if (!wrapper.contains(target)) {
        return;
      }
      const isKeyboardFocus = target === null || target === void 0 || (_target$classList = target.classList) === null || _target$classList === void 0 ? void 0 : _target$classList.contains('svs-keyboard-focus');

      if (isKeyboardFocus) {
        const targetTag = target.tagName ? target.tagName.toLowerCase() : '';
        if (target.tabIndex >= 0 || INTERACTIVE_ELEMENT_TAGS.includes(targetTag)) {
          scrollIntoViewWithOffset(target, {
            offsetTop,
            offsetBottom
          });
        }
      }
    }
    wrapper.addEventListener('focusin', handleFocus);
    return () => {
      wrapper.removeEventListener('focusin', handleFocus);
    };
  }, [offsetTop, offsetBottom]);
  return wrapperRef;
};
setGlobal('svs.components.lbUtils.assistedFocusScroll', {
  useAssistedFocusScroll
});

 })(window);